import React from 'react';
import { Play } from 'lucide-react';

interface GameStartPageProps {
  gameTitle: string;
  onStart: () => void;
}

export const GameStartPage: React.FC<GameStartPageProps> = ({ gameTitle, onStart }) => {
  return (
    <div className="max-w-4xl mx-auto px-6 py-12">
      <div className="bg-white/90 dark:bg-gray-800/90 backdrop-blur-lg rounded-2xl shadow-xl p-8 border border-gray-100 dark:border-gray-700 text-center">
        <h2 className="text-3xl font-bold mb-4 text-gray-900 dark:text-gray-100">
          {gameTitle}
        </h2>
        <p className="text-lg text-gray-600 dark:text-gray-400 mb-8">
          Ready to test your skills?
        </p>
        <button
          onClick={onStart}
          className="inline-flex items-center gap-2 px-8 py-4 bg-gradient-to-r from-green-600 to-emerald-600 hover:from-green-700 hover:to-emerald-700 text-white font-bold rounded-lg transition-all shadow-lg hover:shadow-xl text-lg"
        >
          <Play className="w-6 h-6" />
          Start Game
        </button>
      </div>
    </div>
  );
};
